import { render } from "./fail.vue?vue&type=template&id=14d874d2"
import script from "./fail.vue?vue&type=script&lang=js"
export * from "./fail.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\28950\\source\\repos\\xtz\\hql\\bm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__